import { p as prisma } from "../../../../chunks/prisma.js";
const load = async ({ params, locals }) => {
  const user = locals.user;
  if (!user) {
    return { status: 302, redirect: "/login" };
  }
  const id = Number(params.id);
  const doc = await prisma.document.findUnique({ where: { id } });
  const watermark = user?.email || user?.name || `user-${user?.id}`;
  return { pageCount: doc?.pageCount, watermark, docId: id };
};
export {
  load
};
